import * as axios from "axios"
import { useEffect, useState } from "react"
import { getPaywallSettingsFromLocalStorage } from "./authOperations"
import { getPaywallAccessData } from "./paywallApiUrls"
import { CustomerAccessData } from "./paywallInterfaces"
import { hasProductClientId, ynetProductClientId } from "./paywallUtils"

const isYplusArticlePage = () =>
    typeof document !== "undefined" && !!document.querySelector(".yplus")

const getInitialPremiumAccess = (): boolean => {
    if (typeof document === "undefined") {
        return true
    }
    return !isYplusArticlePage()
}

export const useYplusPremiumAccess = (): boolean => {
    const [hasPremiumAccess, setHasPremiumAccess] = useState<boolean>(getInitialPremiumAccess())

    useEffect(() => {
        if (!isYplusArticlePage()) {
            return
        }

        const checkForAccess = async () => {
            const userDetails = getPaywallSettingsFromLocalStorage()
            if (!userDetails) {
                setHasPremiumAccess(false)
                return
            }
            try {
                const response = await axios.get<{ data: CustomerAccessData }>(getPaywallAccessData())
                const accessData = response && response.data && response.data.data as CustomerAccessData
                const hasProducts = accessData && hasProductClientId(accessData.claims, ynetProductClientId)
                setHasPremiumAccess(!!hasProducts)
            } catch (error) {
                console.error("Error fetching customer access data:", error)
                setHasPremiumAccess(false)
            }
        }

        checkForAccess()
    }, [])

    return hasPremiumAccess
}
